// Operator app shell — three-region layout: left rail (nav) + top bar
// + content slot. Differs from customer-web's AppShell in two ways:
//
//  1. NO right-rail AI drawer. Operator AI surface (if it ships) goes
//     through a different pattern (plan madde 11 keeps the right rail
//     for impersonation banner + sudo timer).
//  2. Top bar carries an INTERNAL badge so an operator never confuses
//     this surface with a customer-facing one (mis-pane mistakes are
//     the worst kind in cross-tenant tooling).
//
// Plan madde 11 hardens with: persistent impersonation banner, sudo
// timer countdown, full-page "INTERNAL" watermark. B1 restyled the
// chrome to the İç Panel graphite language (panel/Shell.jsx): dark
// rail + dark top bar around a light working canvas — operators feel
// "behind the curtain" while page content stays on the shared novem
// canvas tokens.

import { Outlet } from "react-router";

import { useApplyResolvedLocale } from "@/i18n/useApplyResolvedLocale";

import { LeftRail } from "./LeftRail";
import { TopBar } from "./TopBar";

export function AppShell(): React.ReactElement {
  // App.tsx'te DEĞİL: useOperatorMe'nin `enabled` kapısı yok, kök seviyede
  // mount edilirse oturum açılmadan /ops/v1/me'ye 401 atardı. AppShell
  // yalnızca RequireOperatorAuth altında render ediliyor.
  useApplyResolvedLocale();

  return (
    <div className="flex h-full">
      <LeftRail />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        {/* Telefonda 2×36px kenar boşluğu ekranın beşte birini yerdi
            (SEM-4931). */}
        <main
          className="min-w-0 flex-1 overflow-auto bg-[var(--bg-surface)] px-4 py-5 md:px-9 md:py-8"
          id="main-content"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
